import { GetFromStorage } from '@/vessi.utils';

// initial state	
export default () => ({
	username: '',
	siiToken: '',
	isloading: false,
	auth:{
		status: null,
		error:''
	},
	permisos:[],
	esRepresentante: false,
	isloadingPermisos: false,
	consultas:[]
});